<main id="main">
  <!-- ======= Breadcrumbs ======= -->
  <div class="breadcrumbs" data-aos="fade-in">
    <div class="container">
      <h2>Sthan Darshan</h2>
    </div>
  </div><!-- End Breadcrumbs -->


  <!-- ======= Features Section ======= -->
  <section id="features" class="features" style="margin-top: 20px;">
    <div class="container" data-aos="fade-up">

      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button"
            role="tab" aria-controls="home" aria-selected="true">Filter Search</button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button"
            role="tab" aria-controls="profile" aria-selected="false">Free-Hand Search</button>
        </li>

      </ul>
      <div class="tab-content" id="myTabContent">
        <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
          <div class="section-title pb-0 pt-4">
            <h2>List of all City</h2>
          </div>

          <select #mySelect class="form-select marathi-font" aria-label="Default select example"
            (change)="refreshTaluka(mySelect.value)">
            <option selected>ALL</option>
            <option [value]="city.cityid" *ngFor="let city of cities">{{city.marathiname}}</option>
          </select>

          <br>
          <div class="section-title pb-0">
            <h2>List of all Taluka</h2>
          </div>

          <select #myTaluka class="form-select marathi-font" aria-label="Default select example"
            (change)="refreshVillage(myTaluka.value)">
            <option selected>Select</option>
            <option [value]="taluka.talukaid" *ngFor="let taluka of filteredtalukas">{{taluka.marathiname}}</option>
          </select>


          <br>
          <div class="section-title pb-0">
            <h2>List of all Sthan</h2>
          </div>

          <div class="row marathi-font" data-aos="zoom-in" data-aos-delay="100">
            <div class="col-xl-2 col-lg-2 col-md-4 col-sm-6 col-6 mt-2" *ngFor="let village of filteredvillages">
              <div class="icon-box">
                <i class="ri-store-line" style="color: #ffbb2c;"></i>
                <h3 class="marathi-font-lg">{{village.marathiname}}</h3>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
          <div class="section-title pb-0 pt-4">
            <h2>List of all Sthan</h2>
            <div class="ng-autocomplete" >
              <ng-autocomplete 

                [data]="data"
                [searchKeyword]="keyword"
                placeholder="Select country"
                (selected)='selectEvent($event)'
                (inputChanged)='onChangeSearch($event)'
                (inputFocused)='onFocused($event)'
                [itemTemplate]="itemTemplate"
                [notFoundTemplate]="notFoundTemplate">                                 
              </ng-autocomplete>
              
              <ng-template #itemTemplate let-item >
              <a [innerHTML]="item.name" ></a>
              </ng-template>
              
              <ng-template #notFoundTemplate let-notFound> 
              <div [innerHTML]="notFound" s></div>
              </ng-template>
              </div>
          </div>
        </div>
      </div>




    </div>
  </section><!-- End Features Section -->

  <section id="testimonials1" class="pt-1">
    <google-map #myGoogleMap height="500px" width="100%" [zoom]="zoom" [center]="center" [options]="options"
      (mapClick)="eventHandler($event,'mapClick')" (mapDblclick)="eventHandler($event,'mapDblclick')"
      (mapDrag)="eventHandler($event,'mapDrag')" (mapDragend)="eventHandler($event,'mapDragend')"
      (mapRightclick)="eventHandler($event,'mapRightclick')"
      (positionChanged)="eventHandler($event,'marker_positionChanged')" (zoomChange)="changeMapZoom($event)">
      <map-marker #markerElem="mapMarker" *ngFor="let marker of markers" [position]="marker.position"
        [label]="marker.label" [title]="marker.title" [options]="marker.options"
        (mapClick)="openInfo(markerElem, marker.info)"></map-marker>

      <map-info-window>{{ infoContent }}</map-info-window>
    </google-map>

  </section>


</main>